import styled from 'styled-components';

import {
  colorBlack200,
  colorGrey100,
  colorGrey200,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const Container = styled.section`
  background-color: ${colorWhite};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > div:not(:first-child) {
    border-top: 1px solid ${colorGrey100};
  }
`;

export const ButtonMoreProducts = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
  border: 1px solid ${colorGrey200};
  padding: 4px 12px 4px 16px;
  font: 600 13px/20px ${fontFamilyPrimary};
  color: ${colorBlack200};
  background-color: ${colorWhite};
  margin: 0 0 16px 16px;
  width: max-content;
  gap: 8px;
  transition: 0.2s;

  &[data-active='true'] {
    svg {
      transform: rotate(-180deg);
    }
  }

  &:hover {
    opacity: 0.8;
  }
`;
